function popup(state = {
    qrCodePop: '', openProductPop: false, imagePop: { status: 'hide' }, openDialog: false,
    openRejectServicePopup: { show: false }, openReferServicePopup: { show: false }, popupMenu: { show: false },
    popupStorage: { show: false }, popServiceCmbItems: { show: false }, popSelectStaff: { show: false },
    popSelectCostCenter: { show: false }, popSelectPropductGroup: { show: false }, referDocumentPop: { show: false },
    reminderPop: { show: false }, mapPop: { show: false }, serialHistoryPop: { show: false }, selectCustomerPop:{show:false}
}, action) {
    switch (action.type) {
        case "SET_QRPOPUP_STATUS":
            return {
                ...state,
                qrCodePop: action.data
            };
        case "SET_PRODUCT_POPUP":
            return {
                ...state,
                openProductPop: action.data
            }
        case "SET_IMAGE_POPUP":
            return {
                ...state,
                imagePop: action.data
            }
        case "SET_DIALOG":
            return {
                ...state,
                openDialog: action.data
            }
        case "SET_REJECTSERVICE_POPUP":
            return {
                ...state,
                openRejectServicePopup: action.data
            }
        case "SET_REFERSERVICE_POPUP":
            return {
                ...state,
                openReferServicePopup: action.data
            }
        case "SET_POPUP_MENU":
            return {
                ...state,
                popupMenu: action.data
            }
        case "SET_STORAGE_POP":
            return {
                ...state,
                popupStorage: action.data
            }
        case "SET_SERVICE_CMB_POP":
            return {
                ...state,
                popServiceCmbItems: action.data
            }
        case "SET_SELECTSTAFF_POPUP":
            return {
                ...state,
                popSelectStaff: action.data
            }
        case "SET_SELECT_COSTCENTER_POPUP":
            return {
                ...state,
                popSelectCostCenter: action.data
            }
        case "SET_SELECT_PRODUCTGROUP_POP":
            return {
                ...state,
                popSelectPropductGroup: action.data
            }
        case "REFERDOC_POP":
            return {
                ...state,
                referDocumentPop: action.data
            }
        case "REMINDER_POP":
            return {
                ...state,
                reminderPop: action.data
            }
        case "MAP_POP":
            return {
                ...state,
                mapPop: action.data
            }
        case "SERIAL_HISTORY_POP":
            return {
                ...state,
                serialHistoryPop: action.data
            }
            case "SET_CUSTOMER_POPUP":
                return {
                  ...state,
                  selectCustomerPop: action.data
                }
        default:
            return state;
    }
}
export default popup;